import React, { useState, useEffect } from "react";
import EventItemCard from "./EventItemCard";
import { fetchFinancialNewsEvents } from "../../../api/feed/feedAPI";
import LoadingPlaceholder from "../../../components/ui/loading/LoadingPlaceholder";

function FinancialEventsList({ onEventClick }) {
  const [events, setEvents] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const loadAllEvents = async () => {
      try {
        setIsLoading(true);
        const res = await fetchFinancialNewsEvents(1, 100);
        if (res.success) {
          setEvents(res.data || []);
        }
      } catch (err) {
        console.error("Failed to load full events list:", err);
      } finally {
        setIsLoading(false);
      }
    };

    loadAllEvents();
  }, []);

  if (isLoading) {
    return (
      <div style={{ padding: "20px 0" }}>
        <LoadingPlaceholder rows={3} type="card" />
      </div>
    );
  }

  return (
    <div className="standard-container financial-news-events-card">
      <div className="rules-list-group">
        {events.map((eventItem, index) => {
          const isLast = index === events.length - 1;
          const eventKey =
            eventItem.uuid || eventItem.external_event_id || `event-${index}`;

          return (
            <EventItemCard
              key={eventKey}
              eventItem={eventItem}
              isLast={isLast}
              onEventClick={onEventClick}
            />
          );
        })}
      </div>
    </div>
  );
}

export default FinancialEventsList;
